<template>
  <LineChartGenerator
    :chart-options="chartOptions"
    :chart-data="chartData"
    :height="100"
  />
</template>

<script>
import { Line as LineChartGenerator } from "vue-chartjs/legacy"

import {
  Chart as ChartJS,
  Title,
  Tooltip,
  Legend,
  LineElement,
  LinearScale,
  CategoryScale,
  PointElement
} from "chart.js"

ChartJS.register(
  Title,
  Tooltip,
  Legend,
  LineElement,
  LinearScale,
  CategoryScale,
  PointElement
)

export default {
  props: {
    data: { type: Array, default: () => [] },
    labels: { type: Array, default: () => [] }
  },
  components: {
    LineChartGenerator
  },
  data: function() {
    return {}
  },
  computed: {
    chartData() {
      const data = {
        labels: this.labels,
        datasets: [
          {
            data: this.data,
            // label: "Members",
            pointBackgroundColor: "#CC8556",
            // backgroundColor: "#DFC79B",
            borderColor: "#DFC79B"
            // fill: '#ff0000',
            // clip: {bottom: 0}
          }
        ]
      }
      return data
    },
    chartOptions() {
      return {
        animation: false,
        plugins: { legend: { display: false } },
        responsive: true,
        scales: {
          x: {
            // grid: {
            //   display: false
            // }
          },
          y: {
            // grid: { display: false },
            ticks: {
              // precision: 0
            }
          }
        }
      }
    }
  }
}
</script>
